import { BaseModel } from '/@/modules/core/app/models/abstracts/BaseModel';

export class County extends BaseModel {
  /**
   * @var {number}
   */
  id;

  /**
   * @var {string}
   */
  name;

  /**
   * @var {string}
   */
  countyFips;

  /**
   * @var {string}
   */
  probateSignatureType;

  /**
   * @var {string}
   */
  website;

  /**
   * @var {number}
   */
  jurisdictionId;

  constructor(model = {}) {
    super();

    this.id = model.id;
    this.name = model.name;
    this.countyFips = model.countyFips;
    this.probateSignatureType = model.probateSignatureType;
    this.website = model.website;
    this.jurisdictionId = model.jurisdictionId;
  }
}
